export const itemsPerPageOptions = [10, 25, 50, 100];
